import circle from "../../assets/circle-shape/circle-shapeMain.svg";

export default function CircleBgMain() {
  return (
    <>
      <div className=" hidden md:block absolute left-[-50%] top-[45%] w-[600px]">
        <img src={circle} alt="circle" />
      </div>
    </>
  );
}
